import { ArrowOut16, Header5, InlineText2 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './index.css';

export const TooltipContent: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Header5>Коворкинг на 38% дешевле</Header5>
      <InlineText2>обычного офиса, по результатам</InlineText2>
      <InlineText2>нашего исследования</InlineText2>
      <a className={styles['link']} target="_blank" href="https://promo.cian.ru/coworking">
        <InlineText2 color="primary_100">Подробный разбор</InlineText2>
        <span className={styles['icon']}>
          <ArrowOut16 color="primary_100" />
        </span>
      </a>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';
